"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TODO_STATUS = void 0;
var toJSON_1 = __importDefault(require("./toJSON"));
var toText_1 = __importDefault(require("./toText"));
var TODO_STATUS;
(function (TODO_STATUS) {
    TODO_STATUS["COMPLETED"] = "COMPLETED";
    TODO_STATUS["NEED_ACTION"] = "NEEDS-ACTION";
})(TODO_STATUS = exports.TODO_STATUS || (exports.TODO_STATUS = {}));
var ICalParser = {
    toJSON: toJSON_1.default,
    toString: toText_1.default,
};
exports.default = ICalParser;
